import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ isAuth, role, component: Component }) => {
  return isAuth ? <Component role={role} /> : <Navigate to="/sign-in" />;
};

export default ProtectedRoute;